import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { SaveViewOptions } from '../../../api/commands';
import { StorymapState, ViewType } from '../../types';
import { currentViewOptions } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetShouldShowIssueTypeBlock extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetShouldShowIssueTypeBlock';

    public constructor(public isEnabled: boolean) {
        super(SetShouldShowIssueTypeBlock.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetShouldShowIssueTypeBlock): Promise<boolean> => {
    useSendCommand(action, {
        createCommand: () =>
            new SaveViewOptions(
                state.id,
                state.currentViewType,
                currentViewOptions.value.isShowPrioritization,
                currentViewOptions.value.isShowAnnotation,
                currentViewOptions.value.isShowPersonaBlock,
                action.isEnabled,
                currentViewOptions.value.isShowAssignee
            ),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetShouldShowIssueTypeBlock): void => {
    if (state.currentViewType === ViewType.Discovery) {
        state.discoveryViewOptions.isShowIssueType = action.isEnabled;
    }

    if (state.currentViewType === ViewType.Planning) {
        state.planningViewOptions.isShowIssueType = action.isEnabled;
    }

    if (state.currentViewType === ViewType.Backlog) {
        state.backlogViewOptions.isShowIssueType = action.isEnabled;
    }
};

//@ts-ignore
registerMiddleware(SetShouldShowIssueTypeBlock.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetShouldShowIssueTypeBlock.ACTION_TYPE, reducer);
